/* globals FileReader */

import React, { Component, PropTypes } from 'react'
import R from 'ramda'
import CardContainer from '../../components/CardContainer'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import Grid, { Half, Third } from 'grid-styled'
import AdminNavbar from '../../components/AdminNavbar'
import ThemeContainer from '../../components/ThemeContainer'
import Input from '../../components/Input'
import { maxPrice, maxArea, maxRooms, maxYield } from '../../Utils/Constants'
import {
  searchUsers,
  createUser,
  updateUser,
  deleteUser,
  uploadNda
} from '../../sources/AdminSource'
import {
  searchCategories,
  searchLocations,
  searchProperty
} from '../../sources/SearchSource'
import {
  addPreference,
  removePreference,
  fetchPreferences
} from '../../sources/UserSource'
import { Metrics, Colors, Fonts } from '../../Themes'
import { numberWithCommas } from '../../Utils'
import Avatar from '../../components/Avatar'
import Textarea from '../../components/Textarea'
import Dropdown from '../../components/Dropdown'
import SearchableDropdown from '../../components/SearchableDropdown'
import BackArrow from '../../svg-icons/BackArrow'
import Switch from '../../components/Switch'
import RangePicker from '../../components/RangePicker'
import Trash from '../../svg-icons/Trash'
import Button from '../../components/Button'
import { validateInput } from '../../Utils/Validations'
import DialogModal from '../../components/Modal/DialogModal'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'
import { userDefault, preferenceDefault } from '../../Utils/Defaults'
import { withRouter } from 'react-router'

const Container = styled.div``

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const BackArrowContainer = styled.div`
  margin-top: ${Metrics.margins.larger};
  span {
    ${Fonts.style.Header};
    margin-left: ${Metrics.margins.medium};
  }

  svg {
    cursor: pointer;
  }
`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const FormTitle = styled.div`
  ${Fonts.style.Label};
  color: ${props => (props.primary ? Colors.primary : Colors.black)};
  margin-bottom: ${Metrics.margins.small};
`

const Text = styled.div`${Fonts.style.Text};`

const CustomGrid = styled(Grid)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
  .right {
    float: right;
  }
  .left: {
    float: left;
  }
`

const CustomThird = styled(Third)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
`

const CustomHalf = styled(Half)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
  .right {
    float: right;
  }
`

const EditPreferenceArea = styled.div`
  border-bottom: ${Metrics.borders.default};
  padding-bottom: ${Metrics.margins.base};
`

const ViewNdaButton = styled.a`
  width: 110px;
  ${Fonts.style.Button};
  border: 1px solid transparent;
  padding: ${Metrics.margins.small} ${Metrics.margins.large};
  background: ${Colors.black};
  cursor: pointer;
  color: ${Colors.white};
  outline: none;
  text-transform: uppercase;
  text-decoration: none;
  float: left;

  &:hover {
    border: 1px solid ${Colors.black};
    background: transparent;
    color: ${Colors.black};
  }
`

const PreferenceContainer = styled.div`
  border-bottom: ${Metrics.borders.headerBorder};
  padding: ${Metrics.margins.base} 0;
  position: relative;
`

const CustomTrash = styled(Trash)`
  position: absolute;
  top: ${Metrics.margins.base};
  right: 0;
`

const UploadButton = styled.label`
  ${Fonts.style.Button};
  width: auto;
  display: inline-block;
  border: 1px solid transparent;
  padding: ${Metrics.margins.small} ${Metrics.margins.large};
  background: ${Colors.black};
  cursor: pointer;
  color: ${Colors.white};
  outline: none;
  text-transform: uppercase;

  &:hover {
    border: 1px solid ${Colors.black};
    background: transparent;
    color: ${Colors.black};
  }
`

const NdaContainer = styled.div`
  position: relative;
  float: left;
  cursor: pointer !important;
  margin-right: ${Metrics.margins.base};
  input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
`

class AdminUserDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      creation: false,
      properties: [],
      locations: [],
      categories: [],
      searchProperty: '',
      searchCategory: '',
      searchLocation: '',
      user: R.clone(userDefault),
      userPreferences: [],
      modal: false,
      locationType: null,
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        address: '',
        imageUpload: ''
      },
      preference: R.clone(preferenceDefault),
      isSaved: true
    }
    this.personalInfo = this.personalInfo.bind(this)
    this.otherInfo = this.otherInfo.bind(this)
    this.preferences = this.preferences.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
    this.handleSwitch = this.handleSwitch.bind(this)
    this.handleChangeGeneric = this.handleChangeGeneric.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDropdownSelect = this.handleDropdownSelect.bind(this)
    this.handleSelectCategory = this.handleSelectCategory.bind(this)
    this.handleAddPreference = this.handleAddPreference.bind(this)
    this.handleRemovePreference = this.handleRemovePreference.bind(this)
    this.handleRange = this.handleRange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.handleValidate = this.handleValidate.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.fetchUser = this.fetchUser.bind(this)
    this.handleUploadNda = this.handleUploadNda.bind(this)
    this.handleSelectLocationType = this.handleSelectLocationType.bind(this)
    this.handleUploadImageError = this.handleUploadImageError.bind(this)
    this.routerWillLeave = this.routerWillLeave.bind(this)
  }

  componentWillMount () {
    const { params } = this.props
    searchCategories()
      .then(response => this.setState({ categories: response.data }))
      .catch(error => console.log(error))
    if (params.id === 'new') {
      this.setState({ creation: true })
    } else {
      this.fetchUser()
    }
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave)
  }

  routerWillLeave (nextLocation) {
    const { t } = this.props

    if (!this.state.isSaved)
      return t('Your changes are not saved! Are you sure you want to leave?')
  }

  handleValidate (name, value, errors) {
    let newErrors = validateInput(name, value, errors)
    this.setState({ errors: newErrors })
  }

  validateForm () {
    let { errors, user } = this.state
    const requiredFields = document.querySelectorAll('[required]')
    let valid = true
    requiredFields.forEach(field => {
      const name = field.id || field.name
      errors = validateInput(name, user[name], errors)
      valid = valid && errors[name] === ''
    })
    this.setState({ errors })
    return valid
  }

  handleUpload (file, result) {
    let user = R.clone(this.state.user)
    user.picture = { file, result }
    this.setState({
      user,
      errors: { ...this.state.errors, imageUpload: '' },
      isSaved: false
    })
  }

  handleUploadImageError (error) {
    const { errors, user } = this.state

    const update = {
      errors: { ...errors, imageUpload: error },
      user: { ...user, picture: null }
    }
    this.setState(update)
  }

  handleUploadNda (event) {
    let { user } = this.state
    if (event.target.files) {
      const reader = new FileReader()
      const file = event.target.files[0]
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        user.nda = file
        uploadNda(user)
          .then(response => {
            user.nda = response.data.nda
            this.setState({ user, modal: 'success' })
          })
          .catch(error => console.log(error))
      }
    }
  }

  handleSubmit () {
    const { user, creation } = this.state
    if (this.validateForm()) {
      if (creation) {
        createUser(user)
          .then(response => {
            console.log(response)
            this.setState({
              user: response.data,
              modal: 'success',
              creation: false,
              isSaved: false
            })
          })
          .catch(error => {
            console.log(error)
            this.setState({ modal: 'error' })
          })
      } else {
        delete user.preferences
        updateUser(user)
          .then(response =>
            this.setState({
              user: response.data,
              modal: 'success',
              isSaved: true
            })
          )
          .catch(error => {
            console.log(error)
            this.setState({ modal: 'error' })
          })
      }
    }
  }

  handleDelete () {
    const { router } = this.props
    deleteUser(this.state.user).then(res => router.goBack()).catch(error => {
      console.log(error)
      this.setState({ modal: 'error' })
    })
  }

  handleChangeGeneric (event, key) {
    let state = R.clone(this.state)
    const value = event.target.value
    switch (key) {
      case 'property':
        this.setState({ searchProperty: value }, () => {
          searchProperty({ where: { name: { startsWith: value } } })
            .then(response =>
              this.setState({
                properties: response.data,
                isSaved: false
              })
            )
            .catch(error => console.log(error))
        })
        break
      case 'location':
        searchLocations({ criteria: value })
          .then(res => {
            const { cities, countries, continents } = res.data
            this.setState({
              searchLocation: value,
              isSaved: false,
              locations: [
                ...cities.map(city => ({
                  ...city,
                  type: 'city'
                })),
                ...countries.map(country => ({ ...country, type: 'country' })),
                ...continents.map(continent => ({
                  ...continent,
                  type: 'continent'
                }))
              ]
            })
          })
          .catch(error => console.log(error))
        break
      case 'category':
        this.setState({ searchCategory: value }, () => {
          searchCategories({ where: { name: { startsWith: value } } })
            .then(response =>
              this.setState({
                categories: response.data,
                isSaved: false
              })
            )
            .catch(error => console.log(error))
        })
        break
      case 'preferenceName':
        let { preference } = this.state
        preference.name = value
        this.setState({
          preference,
          isSaved: false
        })
        break
      default:
        state[key] = value
        this.setState({
          state,
          isSaved: false
        })
        break
    }
  }

  handleChange (event, key) {
    const { user } = this.state
    user[key] = event.target.value
    this.setState({
      user,
      isSaved: false
    })
  }

  handleDropdownSelect (el) {
    const { preference } = this.state

    preference[el.type] = el

    return this.setState({
      searchLocation: el.name,
      preference,
      isSaved: false
    })
  }

  handleRemovePreference (preference) {
    removePreference(preference.id)
      .then(response => this.fetchUser())
      .catch(error => console.log(error))
  }

  handleAddPreference () {
    addPreference(this.state.user.id, this.state.preference)
      .then(response => {
        this.setState(
          {
            isSaved: false,
            searchLocation: '',
            preference: {
              name: '',
              city: null,
              category: null,
              country: null,
              continent: null,
              minNoRooms: 0,
              maxNoRooms: maxRooms,
              minYield: 0,
              maxYield: maxYield,
              minPrice: 0,
              maxPrice: maxPrice,
              minArea: 0,
              maxArea: maxArea
            }
          },
          () => this.fetchUser()
        )
      })
      .catch(error => console.log(error))
  }

  handleSwitch (key) {
    let user = R.clone(this.state.user)
    user[key] = !user[key]
    this.setState({
      user,
      isSaved: false
    })
  }

  handleRange (minKey, maxKey) {
    return value => {
      let { preference } = this.state
      preference[minKey] = value.min
      preference[maxKey] = value.max
      this.setState({
        preference,
        isSaved: false
      })
    }
  }

  handleSelectCategory (el) {
    const { preference } = this.state
    preference.category = el
    this.setState({
      preference,
      isSaved: false
    })
  }

  handleSelectLocationType (type) {
    this.setState({ locationType: type === 'None' ? null : type })
  }

  closeModal () {
    this.setState({ modal: false })
  }

  openModal (modal) {
    this.setState({ modal })
  }

  personalInfo () {
    const { user, errors } = this.state
    const { t } = this.props
    return (
      <CustomCardContainer title={t('Personal Info')}>
        <CustomGrid noPadLeft noPadRight noPadTop>
          <FormTitle>{t('Profile Picture')}</FormTitle>
          <Avatar
            imageSrc={user.picture && (user.picture.result || user.picture)}
            size={140}
            onEdit={this.handleUpload}
            handleError={this.handleUploadImageError}
            error={errors['imageUpload']}
          />
        </CustomGrid>
        <CustomHalf noPadLeft>
          <Input
            title={t('First Name')}
            required
            handleChange={event => this.handleChange(event, 'firstName')}
            value={user.firstName}
            placeholder={t('Insert user first name')}
            error={errors['firstName']}
            name='firstName'
            handleBlur={event =>
              this.handleValidate('firstName', user.firstName, errors)}
          />
        </CustomHalf>
        <CustomHalf noPadRight>
          <Input
            title={t('Last Name')}
            required
            handleChange={event => this.handleChange(event, 'lastName')}
            value={user.lastName}
            placeholder={t('Insert user last name')}
            error={errors['lastName']}
            name='lastName'
            handleBlur={event =>
              this.handleValidate('lastName', user.lastName, errors)}
          />
        </CustomHalf>
        <CustomHalf noPadLeft>
          <Input
            title={t('E-mail')}
            required
            handleChange={event => this.handleChange(event, 'email')}
            value={user.email}
            placeholder={t('Insert user email')}
            error={errors['email']}
            name='email'
            handleBlur={event =>
              this.handleValidate('email', user.email, errors)}
          />
        </CustomHalf>
        <CustomHalf noPadRight>
          <Input
            title={t('Phone Number')}
            required
            handleChange={event => this.handleChange(event, 'phoneNumber')}
            value={user.phoneNumber}
            placeholder={t('Insert user phone number')}
            error={errors['phoneNumber']}
            name='phoneNumber'
            handleBlur={event =>
              this.handleValidate('phoneNumber', user.phoneNumber, errors)}
          />
        </CustomHalf>
        <CustomGrid noPadLeft noPadRight>
          <Input
            title={t('Address')}
            required
            handleChange={event => this.handleChange(event, 'address')}
            value={user.address}
            placeholder={t('Insert user address')}
            error={errors['address']}
            name='address'
            handleBlur={event =>
              this.handleValidate('address', user.address, errors)}
          />
        </CustomGrid>
        <CustomHalf noPadLeft>
          <Input
            title={t('Company')}
            handleChange={event => this.handleChange(event, 'company')}
            value={user.company}
            placeholder={t('Insert user company')}
          />
        </CustomHalf>
        <CustomHalf noPadRight>
          <Input
            title={t('Job Title')}
            handleChange={event => this.handleChange(event, 'jobTitle')}
            value={user.jobTitle}
            placeholder={t('Insert user job title')}
          />
        </CustomHalf>
        <CustomGrid noPadLeft noPadRight>
          <Textarea
            title={t('Brief Description')}
            handleChange={event => this.handleChange(event, 'description')}
            value={user.description}
            placeholder={t('Insert user description')}
          />
        </CustomGrid>
        <CustomHalf noPadLeft>
          <Input
            title={t('City')}
            handleChange={event => this.handleChange(event, 'city')}
            value={user.city}
            placeholder={t('Insert city')}
          />
        </CustomHalf>
        <CustomHalf noPadRight>
          <Input
            title={t('Country')}
            handleChange={event => this.handleChange(event, 'country')}
            value={user.country}
            placeholder={t('Insert country')}
          />
        </CustomHalf>
        <CustomHalf noPadLeft>
          <Input
            title={t('Skype Name')}
            handleChange={event => this.handleChange(event, 'skypeName')}
            value={user.skypeName}
            placeholder={t('Insert user skype name')}
          />
        </CustomHalf>
        <CustomHalf noPadRight>
          <Input
            title={t('Linkedin Profile')}
            handleChange={event => this.handleChange(event, 'linkedinUrl')}
            value={user.linkedinUrl}
            placeholder={t('Insert user linkedin profile')}
          />
        </CustomHalf>
      </CustomCardContainer>
    )
  }

  otherInfo () {
    const { user, creation } = this.state
    const { t } = this.props
    return (
      <CustomCardContainer title={t('Documents and Other Info')}>
        {!creation && (
          <CustomGrid noPadLeft noPadTop>
            <FormTitle>{t('NDA')}</FormTitle>
            <CustomGrid xs={1} noPadLeft noPadTop>
              <NdaContainer>
                <input
                  type='file'
                  name='nda-upload'
                  id='nda-upload'
                  onChange={this.handleUploadNda}
                />
                <UploadButton htmlFor='nda-upload'>{t('Upload')}</UploadButton>
              </NdaContainer>
              {user.nda && (
                <ViewNdaButton href={user.nda} target='_blank'>
                  {t('View Nda')}
                </ViewNdaButton>
              )}
            </CustomGrid>
          </CustomGrid>
        )}
        <CustomGrid noPadLeft noPadTop>
          <CustomHalf noPadLeft>
            <FormTitle>{t('Permissions')}</FormTitle>
            <Text>{t('Has this user full access?')}</Text>
          </CustomHalf>
          <CustomHalf noPadRight>
            <Switch
              className='right'
              active={user.hasFullAccess}
              onClick={() => this.handleSwitch('hasFullAccess')}
            />
          </CustomHalf>
        </CustomGrid>
        {user.recommendedBy && (
          <CustomGrid noPadLeft noPadTop>
            <CustomHalf noPadLeft>
              <FormTitle>{t('Recommended by')}</FormTitle>
              <Text>{user.recommendedBy}</Text>
            </CustomHalf>
          </CustomGrid>
        )}
      </CustomCardContainer>
    )
  }

  preferences () {
    const {
      categories,
      locations,
      preference,
      userPreferences,
      searchLocation
    } = this.state
    const { t } = this.props
    return (
      <CustomCardContainer title={t('Preferences')}>
        <EditPreferenceArea>
          <CustomThird noPadLeft noPadTop>
            <Input
              title={t('Name')}
              placeholder={t('Insert the preference name')}
              handleChange={event =>
                this.handleChangeGeneric(event, 'preferenceName')}
              value={preference.name}
            />
          </CustomThird>
          <CustomThird noPadTop>
            <FormTitle>{t('Property Type')}</FormTitle>
            <Dropdown
              accessor={el => el.name}
              handleSelect={el => this.handleSelectCategory(el)}
              placeholder={t('Choose your favourite categories')}
              options={categories}
              selectedOption={preference.category}
            />
          </CustomThird>
          <CustomThird noPadRight noPadTop>
            <FormTitle>{t('Location')}</FormTitle>
            <SearchableDropdown
              value={searchLocation}
              placeholder={t('Choose location')}
              options={locations}
              handleSearch={event =>
                this.handleChangeGeneric(event, 'location')}
              handleSelect={el => this.handleDropdownSelect(el)}
              accessor={location => location.name}
            />
          </CustomThird>
          <CustomGrid noPadLeft sm={1 / 4}>
            <RangePicker
              title={t('Number of Keys')}
              max={maxRooms}
              minValue={preference.minNoRooms}
              maxValue={preference.maxNoRooms}
              handleChange={value =>
                this.handleRange('minNoRooms', 'maxNoRooms')(value)}
            />
          </CustomGrid>
          <CustomGrid sm={1 / 4}>
            <RangePicker
              title={t('Estimated Yield')}
              max={maxYield}
              minValue={preference.minYield}
              maxValue={preference.maxYield}
              handleChange={value =>
                this.handleRange('minYield', 'maxYield')(value)}
              unit={'%'}
              rightUnit
            />
          </CustomGrid>
          <CustomGrid sm={1 / 4}>
            <RangePicker
              title={t('Price')}
              max={maxPrice}
              minValue={preference.minPrice}
              maxValue={preference.maxPrice}
              handleChange={value =>
                this.handleRange('minPrice', 'maxPrice')(value)}
              unit={'€'}
            />
          </CustomGrid>
          <CustomGrid sm={1 / 4}>
            <RangePicker
              title={t('Area')}
              max={maxArea}
              minValue={preference.minArea}
              maxValue={preference.maxArea}
              handleChange={value =>
                this.handleRange('minArea', 'maxArea')(value)}
              unit={'m2'}
              rightUnit
            />
          </CustomGrid>
          <CustomGrid noPadLeft noPadRight>
            <Button
              className='right'
              label={t('Add')}
              onClick={this.handleAddPreference}
            />
          </CustomGrid>
        </EditPreferenceArea>
        {userPreferences.length > 0 &&
          userPreferences.map((pref, index) => {
            return (
              <PreferenceContainer key={`pref-${index}`}>
                <CustomGrid noPadLeft noPadRight noPadTop>
                  <FormTitle primary>{pref.name}</FormTitle>
                </CustomGrid>
                <CustomGrid xs={1 / 6} noPadLeft noPadRight>
                  <FormTitle>{t('Property Type')}</FormTitle>
                  <Text>{pref.category.name}</Text>
                </CustomGrid>
                <CustomGrid xs={1 / 6} noPadLeft noPadRight>
                  {pref.city && (
                    <div>
                      <FormTitle>{t('City')}</FormTitle>
                      <Text key={`key-city-${index}`}>{pref.city.name}</Text>
                    </div>
                  )}
                  {pref.country && (
                    <div>
                      <FormTitle>{t('Country')}</FormTitle>
                      <Text key={`key-country-${index}`}>
                        {pref.country.name}
                      </Text>
                    </div>
                  )}
                  {pref.continent && (
                    <div>
                      <FormTitle>{t('Continent')}</FormTitle>
                      <Text key={`key-continent-${index}`}>
                        {pref.continent.name}
                      </Text>
                    </div>
                  )}
                </CustomGrid>
                <CustomGrid xs={1 / 6} noPadLeft noPadRight>
                  <FormTitle>{t('Number of Keys')}</FormTitle>
                  <Text>
                    {pref.minNoRooms} -{' '}
                    {pref.maxNoRooms ? pref.maxNoRooms : `${maxRooms}+`}
                  </Text>
                </CustomGrid>
                <CustomGrid xs={1 / 6} noPadLeft noPadRight>
                  <FormTitle>{t('Estimated Yield')}</FormTitle>
                  <Text>
                    {pref.minYield} -{' '}
                    {pref.maxYield ? `${pref.maxYield}%` : `${maxYield}%+`}
                  </Text>
                </CustomGrid>
                <CustomGrid xs={1 / 6} noPadLeft noPadRight>
                  <FormTitle>{t('Price')}</FormTitle>
                  <Text>
                    {pref.minPrice} -{' '}
                    {pref.maxPrice ? (
                      `${numberWithCommas(pref.maxPrice)}€`
                    ) : (
                      `${numberWithCommas(maxPrice)}€+`
                    )}
                  </Text>
                </CustomGrid>
                <CustomGrid xs={1 / 6} noPadLeft noPadRight>
                  <FormTitle>{t('Area')}</FormTitle>
                  <Text>
                    {pref.minArea} -{' '}
                    {pref.maxArea ? (
                      `${numberWithCommas(pref.maxArea)}m2`
                    ) : (
                      `${numberWithCommas(maxArea)}m2+`
                    )}
                  </Text>
                </CustomGrid>
                <CustomTrash
                  onClick={() => this.handleRemovePreference(pref)}
                />
              </PreferenceContainer>
            )
          })}
      </CustomCardContainer>
    )
  }

  fetchUser () {
    const { params } = this.props
    searchUsers({ id: params.id })
      .then(response => {
        this.setState({ user: response.data }, () => {
          let user = this.state.user
          if (user.preferences.length > 0) {
            let criteria = {}
            criteria.id = user.preferences.map(pref => pref.id)
            fetchPreferences(criteria)
              .then(response => {
                this.setState({ userPreferences: response.data.results })
              })
              .catch(error => console.log(error))
          }
        })
      })
      .catch(error => console.log(error))
  }

  render () {
    const { user, creation, modal } = this.state
    const { t, router, admin, dropdownLinks } = this.props

    const actions = [
      { label: t('Save'), primary: true, onClick: this.handleSubmit }
    ]
    if (!creation) {
      actions.push({
        label: t('Delete User'),
        cancel: true,
        onClick: () => this.openModal('dialog')
      })
    }

    return (
      <Container>
        <AdminNavbar
          admin={admin}
          dropdownLinks={dropdownLinks}
          rightSideActions={actions}
        />
        <CustomThemeContainer>
          <DialogModal
            visible={modal === 'dialog'}
            message={t('Are you sure that you want to delete this user?')}
            closeAction={this.closeModal}
            header={t('Delete User')}
            buttons={{
              apply: { label: t('Delete'), onClick: this.handleDelete },
              cancel: { label: t('Cancel'), onClick: this.closeModal }
            }}
          />
          <SuccessModal
            visible={modal === 'success'}
            message={t(`User successfuly ${creation ? 'created' : 'updated'}.`)}
            closeAction={this.closeModal}
            header={t(`User ${creation ? 'Created' : 'Updated'}`)}
          />
          <ErrorModal
            visible={modal === 'error'}
            message={t(
              `There was a problem when ${creation
                ? 'creating'
                : 'updating'} the user`
            )}
            closeAction={this.closeModal}
            header={t('Error')}
          />
          <BackArrowContainer>
            <BackArrow onClick={() => router.goBack()} />
            <span>
              {creation ? (
                t('Insert User')
              ) : (
                `${user.firstName} ${user.lastName}`
              )}
            </span>
          </BackArrowContainer>
          {user && this.personalInfo()}
          {user && this.otherInfo()}
          {user && !creation && this.preferences()}
        </CustomThemeContainer>
      </Container>
    )
  }
}

AdminUserDetails.propTypes = {
  admin: PropTypes.object,
  t: PropTypes.func,
  params: PropTypes.object,
  router: PropTypes.object,
  location: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'forms', 'admin' ], { wait: true })(
  withRouter(AdminUserDetails)
)



// WEBPACK FOOTER //
// ./src/pages/AdminUsers/AdminUserDetails.js